import type { SurfaceHostedIn } from '@hibro/shared';
import { createContext, useContext } from 'react';

/**
 * Which window the current React tree is. Set once at each window root
 * (workbench, gate, detached surface, module shell). `SurfaceView` and
 * `FragmentSurface` read it into props; a module never sees this context.
 *
 * Missing means a view rendered outside a window root. That is a shell bug,
 * so the hook throws instead of pretending to be the workbench.
 */
export const SurfaceHostedInContext = createContext<
  SurfaceHostedIn | undefined
>(undefined);

/** The window this rendering is mounted in. Throws when no root provided one. */
export function useSurfaceHostedIn(): SurfaceHostedIn {
  const value = useContext(SurfaceHostedInContext);
  if (value === undefined) {
    throw new Error(
      'useSurfaceHostedIn: rendered outside a window root (Workbench, GateHost, DetachedSurface, or ModuleShellHost)',
    );
  }
  return value;
}
